// services/authService.ts

import axiosInstance from 'Utils/axiosInstance';
import { base_url } from 'Zustand/constants';
import { LoginResponse } from 'Zustand/types/authTypes';

export const loginUser = async (email: string, password: string): Promise<LoginResponse> => {
  const response = await axiosInstance.post(base_url+'/auth/user/login', { email, password }); // replace with your endpoint

  if (!response.data?.accesstoken) {
    throw new Error(response.data?.message || 'Invalid email or password');
  }

  return response.data;
};

export const loginWithSsoTokenAPI = async (idToken: string): Promise<LoginResponse> => {
  const response = await axiosInstance.post(base_url + '/auth/user/login', { idToken: idToken });

  if (!response.data?.accesstoken) {
    throw new Error(response.data?.message || 'SSO login failed');
  }

  return response.data;
};
